/* eslint-disable camelcase */
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosWIS";

export interface Status extends Record<string, unknown> {
  id: string;
  pk_status_id: number;
  status_name: string;
  status_color: string;
  status_text_color: string;
  status_desc: string;
  status_is_default: boolean;
  status_status: string;
  created_by: string;
  create_timestamp: string;
  update_by: string;
  update_timestamp: string;
  inc_status_type: string;
  version: number;
}

export const useStatus = (
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<Status>> => {
  return useSwr<ApiArrayResponse<Status>>(`/api/Status`, config);
};
